import { Box, Button, Chip, Pagination, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useMemo } from 'react';
import { useVoyageData } from '../../../store';
import VoyageCard from '../components/voyage/VoyageCard';
import CardContainer from '../components/shared/CardContainer';
import CardHeader from '../components/shared/CardHeader';

const VoyageList = ({
  onEditClicked = () => undefined,
  onCancelVoyageClicked = () => undefined,
  onUnCancelVoyageClicked = () => undefined,
  loadingVoyageId = null,
  handleHistoryClick = () => undefined,
}) => {
  const {
    voyages,
    voyagesBase,
    currentPage,
    totalPages,
    fetchVoyagesPage,
    selectedVoyageId,
    clearSelectedVoyageId,
  } = useVoyageData();

  const baseVoyageById = useMemo(() => {
    if (!voyagesBase || !voyagesBase.length) return new Map();
    const map = new Map();
    for (const v of voyagesBase) {
      if (v.id) map.set(v.id, v);
    }
    return map;
  }, [voyagesBase]);

  const filteredVoyages = voyages ?? [];

  if (!filteredVoyages || filteredVoyages.length === 0) {
    return <Typography>No voyages available</Typography>;
  }

  const calculateDaysBetween = (date1, date2) => {
    const diffTime = Math.abs(new Date(date2) - new Date(date1));
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        {selectedVoyageId && (
          <Box sx={{ mb: 2 }}>
            <Button variant='outlined' onClick={clearSelectedVoyageId}>
              Show All Voyages
            </Button>
          </Box>
        )}
        <Grid container spacing={2}>
          {filteredVoyages.map((voyage, index) => {
            let daysBetween = null;
            if (index > 0) {
              daysBetween = calculateDaysBetween(
                filteredVoyages[index - 1].actualETD,
                voyage.actualETD
              );
            }
            return (
              <React.Fragment key={voyage.id}>
                {index > 0 && (
                  <Grid
                    xs={12}
                    sx={{ position: 'relative', textAlign: 'center' }}
                  >
                    <Typography
                      variant='body2'
                      sx={{ color: 'text.secondary', marginBottom: 1 }}
                    >
                      Days Between
                    </Typography>
                    <Chip
                      label={`${daysBetween} Days`}
                      variant='outlined'
                      color='info'
                    />
                  </Grid>
                )}
                <Grid xs={12}>
                  <VoyageCard
                    data={voyage}
                    baseVoyage={baseVoyageById.get(voyage.id) ?? null}
                    daysBetween={daysBetween}
                    CardHeader={CardHeader}
                    CardContainer={CardContainer}
                    onEditClicked={onEditClicked}
                    onCancelVoyageClicked={onCancelVoyageClicked}
                    onUnCancelVoyageClicked={onUnCancelVoyageClicked}
                    loadingVoyageId={loadingVoyageId}
                    handleHistoryClick={handleHistoryClick}
                  />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
        {!selectedVoyageId && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, value) => fetchVoyagesPage(value)}
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default VoyageList;
